import type { ComponentPropsWithoutRef } from 'react'
import classNames from 'classnames'

import styles from './styles/Header.css'

export type HeaderLevel = 1 | 2 | 3 | 4 | 5 | 6

type HeaderProps = ComponentPropsWithoutRef<'h1'> & {
  level?: HeaderLevel
  center?: boolean
  light?: boolean
}

export const Header = ({ className, level = 1, children, center, light, ...rest }: HeaderProps) => {
  const Tag = `h${level}` as const
  return (
    <Tag
      className={classNames(
        styles[Tag],
        {
          [styles.center]: center,
          [styles.light]: light
        },
        className
      )}
      {...rest}
    >
      {children}
    </Tag>
  )
}

export default Header
